import { createStore, applyMiddleware, combineReducers, compose } from "redux"
import createSagaMiddleware from "redux-saga"
import { routerReducer, routerMiddleware } from "react-router-redux"
import { createDckReducer } from "dck-redux"
import { browserHistory } from "react-router"

import * as ItemTypes from "./redux/items/types"
import * as ProcessTypes from "./redux/processes/types"
import rootSaga from "./redux/sagas"
import toastNotifications from "./redux/toastNotifications"
import notifications from "./redux/notifications"
import downloadRequests from "./redux/downloadRequests"

const sagaMiddleware = createSagaMiddleware(),
composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

function configureStore(initialState) {
  return createStore(
    combineReducers({
      dck: createDckReducer(ItemTypes, ProcessTypes),
      toastNotifications,
      notifications,
      downloadRequests,
      routing: routerReducer
    }),
    initialState,
    composeEnhancers(applyMiddleware(sagaMiddleware, routerMiddleware(browserHistory)))
  )
}

export function configureStoreWithoutMiddleware(initialState) {
  return createStore(
    combineReducers({
      dck: createDckReducer(ItemTypes, ProcessTypes)
    }),
    initialState
  )
}

const store = configureStore({})
sagaMiddleware.run(rootSaga)

export default store



// WEBPACK FOOTER //
// ./src/store.js